import View from './View';

export { default as View, getSearchDropdownStyles } from './View';

export default View;
